/**
 * Warteliste-Seite – /warteliste  (NT-ALPHA-REWORK-01)
 *
 * Wird angezeigt, wenn ein verifizierter Spieler auf der Alpha-Warteliste steht
 * (kein freier Slot). Kein Spielzugang – nur Info + Logout.
 * Keine exakte Positionsnummer (v1, vermeidet falsches Erwartungsmanagement).
 */

import { navigate } from '../router.js';
import { gameState } from '../state/gameState.js';
import { logoutUser } from '../services/auth.js';
import { api } from '../services/api.js';

interface WaitlistStatus {
  onWaitlist: boolean;
  priorityReturn: boolean;
}

export function renderWaitlist(): void {
  // Nur für eingeloggte Warteliste-Spieler. Aktive Spieler → Dashboard.
  if (!gameState.isAuthenticated()) {
    navigate('/login');
    return;
  }
  if (!gameState.isWaitlisted()) {
    navigate('/dashboard');
    return;
  }

  const app = document.getElementById('app');
  if (!app) return;

  app.innerHTML = `
    <main class="auth-page">
      <div class="auth-card">
        <p class="auth-brand">&#9654; NIGHTTRADE // CLOSED ALPHA</p>
        <h1 class="auth-title">Du stehst auf der Warteliste</h1>

        <p class="waitlist-note" id="waitlist-main-note">
          Aktuell sind alle Plätze in der Closed Alpha belegt.
          Wir benachrichtigen dich per E-Mail, sobald ein Platz frei wird.
        </p>
        <p class="waitlist-note">Danke für deine Geduld.</p>

        <button type="button" id="waitlist-logout" class="primary btn-full">
          Abmelden
        </button>
      </div>
    </main>
  `;

  const logoutBtn = document.getElementById('waitlist-logout') as HTMLButtonElement | null;
  logoutBtn?.addEventListener('click', (): void => {
    void (async (): Promise<void> => {
      await logoutUser();
      navigate('/');
    })();
  });

  // NT-PLAYER-CAP-01: Rückkehrer aus der Inaktivitäts-Sperrung bekommen eine andere
  // Begrüßung — sie standen schon einmal drin und bekommen jetzt Vorrang.
  void (async (): Promise<void> => {
    try {
      const status = await api.get<WaitlistStatus>('/alpha/waitlist-status');
      if (status.priorityReturn) {
        const note = document.getElementById('waitlist-main-note');
        if (note) {
          note.textContent =
            'Dein Platz wurde freigegeben, du stehst vorne auf der Warteliste. ' +
            'Dein Spielstand ist vollständig erhalten geblieben — wir benachrichtigen dich ' +
            'per E-Mail, sobald wieder ein Platz frei wird.';
        }
      }
    } catch {
      // Best-effort — Standardtext bleibt stehen, kein Fehler-UI nötig.
    }
  })();
}
